<script context="module">
    
</script>
<script>
    import { onMount, onDestroy, afterUpdate, createEventDispatcher} from "svelte";    
    import Keydown from "svelte-keydown";
    import {  getRandomIntInclusive } from "../../../../scripts/utils";
    import { HiloBet} from './HiloBet'
    import {
        getActiveBet
    } from "../../../../scripts/stake-api";


    import { Statistic, initStatistic, Text, Dropdown, initDropdown, controllable, Icon, Segment, Header, Divider, Button,Buttons, Input, Label, initLabel, Form, Fields, Field, Table, initTable } from "svantic";
    initStatistic(), initLabel(), initDropdown(), initTable()

    import { PlayingCard } from "../../../playingcard";
    import { LastBet, BetSettingsLocal } from "../../../../stores";


    let isLoading = false
    let bet
    let activeBetMultiplier = 0
    let activeBetTotalAmount = 0

    let startCard = { suit: "H", rank: "A" }
    let activeCard = {... startCard }

    $: {
        let c
        if(bet?.data?.state?.rounds && bet?.data?.active === true)
            c = (bet.data.state.rounds.length > 0 ? bet.data.state.rounds.at(-1).card : bet.data.state.startCard)
         else
            c = {... startCard}

        activeCard = { ... c}

        if(bet?.data?.state?.rounds.length > 0){
           activeBetMultiplier = Math.round(bet.data.state.rounds.at(-1).payoutMultiplier * 100) / 100
           activeBetTotalAmount = parseFloat(bet.data.amount * activeBetMultiplier).toFixed(8)
        }
        
    }

    let div_rounds

    afterUpdate(()=>{
        if(div_rounds) div_rounds.scrollTo(div_rounds.scrollWidth,0)
    })

    let DropdownStartCardRank = controllable( controller => { })
    let DropdownStartCardSuit = controllable( controller => { })

    const CardRanks = ["A", "2","3", "4", "5", "6", "7", "8", "9", "10", "J","Q","K"]
    const Suits = ["H","D","S","C"]
    const Patterns = {
        D: '♦',
        C: '♣',
        H: '♥',
        S: '♠' 
    }

    let CardCounter = {
        "A": {session: 0, round: 0},
        "2": {session: 0, round: 0},
        "3": {session: 0, round: 0},
         "4": {session: 0, round: 0},
         "5": {session: 0, round: 0},
         "6": {session: 0, round: 0},
         "7": {session: 0, round: 0},
         "8": {session: 0, round: 0},
        "9": {session: 0, round: 0},
         "10": {session: 0, round: 0},
         "J": {session: 0, round: 0},
        "Q": {session: 0, round: 0},
        "K": {session: 0, round: 0},
        
    }
    // bet.result.playerHand
    let testHand = [
        {suit: "H", rank: "3"},
        {suit: "S", rank: "8"},
        {suit: "H", rank: "7"},
        {suit: "D", rank: "2"},
   
        {suit: "C", rank: "K"},
        {suit: "D", rank: "4"},
        {suit: "H", rank: "5"},
        {suit: "C", rank: "3"},
        {suit: "S", rank: "A"},
        {suit: "S", rank: "8"},
        {suit: "C", rank: "3"},
        {suit: "C", rank: "10"},
        {suit: "H", rank: "7"},
        {suit: "D", rank: "2"},
        {suit: "D", rank: "8"},
        {suit: "C", rank: "Q"},
    ]
    /*
    let unsubscribe = LastBet.subscribe((val) =>{
            bet = val
    })
   */
    let Controls = {
        randomStartCard: () => {
            $DropdownStartCardRank.setSelected( CardRanks.at(getRandomIntInclusive(0,12)) )
            
            $DropdownStartCardSuit.setSelected( Suits.at(getRandomIntInclusive(0,3)) )

           // startCard = {... startCard}

          //  console.log(startCard)
        },
        resetCounter: () =>{
            Object.keys(CardCounter).forEach( key => {
                CardCounter[key].session = 0
                CardCounter[key].round = 0
            })

            CardCounter = CardCounter
        }
     }

    onMount(async () =>{
      
        let activeBet = await getActiveBet("hilo")
        console.log(activeBet.data)

        if(activeBet.data){
            bet = new HiloBet(activeBet.data)
           // bet = bet
        }

    })



    const onNext = (betData) => {

        // increase card counter for last card
        if(betData?.state?.rounds.length > 0){
            CardCounter[betData.state.rounds.at(-1).card.rank].session++

            CardCounter=CardCounter
        }
    }

    export const placeBet = async () => {
        let betConfig = {                   
            amount: $BetSettingsLocal.amount,                    
            currency: $BetSettingsLocal.currency,
            startCard: { ... startCard }
        };

        if(bet?.data?.active !== true){

            try {

                bet = new HiloBet()

                isLoading = true
                
                let [err,res] = await bet.bet(betConfig)
            
                if(err)
                    throw err


                return bet = bet
            } catch (error) {
                console.log("[ERROR] HiloBet placeBet")
                console.error(error)
            }
            finally {
                isLoading = false
            }

        }


    }
    export const next = async (guess) => {

        if(bet?.data?.active === true){
            try {               

                if(activeCard.rank == "A" && guess == "higherEqual")
                    guess = "higher"        
                else if(activeCard.rank == "K" && guess == "lowerEqual")
                    guess = "lower"

                isLoading = true
                
                let [err,res] = await bet.next(guess)
                
                if(err)
                    throw err
                
                                    
                onNext(bet.data)
                return bet = bet
            } catch (error) {
                console.log("[ERROR] HiloBet next")
                console.error(error)
            }
            finally {
                isLoading = false
            }

        }


    }

    export const cashout = async () => {
        if(bet?.data?.active === true){

            try {
                isLoading = true
                
                let [err,res] = await bet.cashout()

                if(err)
                    throw err

                return bet = bet
            } catch (error) {
                console.log("[ERROR] HiloBet cashout")
                console.error(error)
            }
            finally {
                isLoading = false
            }

        }

    }
   // onDestroy(unsubscribe)
   // $: console.log(bet)

</script>


<Keydown
  pauseOnInput
  on:r={ Controls.randomStartCard }
  on:t={ Controls.resetCounter }
  on:keydown={(e) => {
    if (e.key === " " && e.target.tagName === "BODY")
     e.preventDefault()
  }}

  on:q={(e) =>{
      if(isLoading)
        return

      next("higherEqual")
  }}

  on:w={(e) =>{
       if(isLoading)
        return
        
      next("lowerEqual")
  }}

  on:s={(e) =>{
       if(isLoading)
        return
        
      next("equal")
  }}
  on:e={(e) =>{
       if(isLoading)
        return
        
      next("skip")
  }}

  on:Space={(e) => {
       if(isLoading)
        return
        
    if(bet?.data?.active === true)
        cashout()
    else
        placeBet()
  }}
/>


<div class="display-container">

    <div class="flex-container">
        <div class="flex-item t-left">

          
            <Segment fitted="vertically" inverted>
                <Header inverted dividing size="tiny"> start card </Header>
               
                <Dropdown
                 button 
                 pointing 
                 size="small"
                 style={{ "min-width": "34px" }} 

                 bind:this={$DropdownStartCardRank}
                 settings={{
                    onChange: (value, text, $selectedItem) => {
                        console.log("dropdown.onchange")
                        startCard.rank = value.toUpperCase(); // custom action
                        startCard = startCard
                    },
                }} >
                    <input name="startCardRank" type="hidden" value={startCard.rank} />
                    <Dropdown.Text> rank </Dropdown.Text>
                    <Dropdown.Menu>		
                        {#each CardRanks as rank}
                             <Dropdown.Item value={rank}>{rank}</Dropdown.Item >
                        {/each}
                       
                    </Dropdown.Menu>
                </Dropdown>


                <Dropdown
                    button                    
                    pointing
                    size="small"
                    style={{ "min-width": "28px" }}
                    bind:this={$DropdownStartCardSuit}
                    onMount={async (controller) => {
                        /*await controller.setValue(startCard.suit);*/
                    }}
                    settings={{
                        onChange: (value, text, $selectedItem) => {
                            console.log("dropdown.onchange")
                            startCard.suit = value.toUpperCase(); // custom action
                            startCard = startCard
                        },
                    }} >
                    <input name="startCardSuit" type="hidden"  value={startCard.suit} />

                    <!-- <Dropdown.text>Select game</Dropdown.text> -->
                    <Dropdown.Text>select suit</Dropdown.Text>
                
                    <!--i class="ui dropdown icon" /-->
                    <Dropdown.Menu>				
                        <Dropdown.Item value="H"><span class="red text">♥</span></Dropdown.Item>
                        <Dropdown.Item value="D"><span class="red text">♦</span></Dropdown.Item>
                        <Dropdown.Item value="S"><span class="black text">♠</span></Dropdown.Item>
                        <Dropdown.Item value="C"><span class="black text">♣</span></Dropdown.Item>					
                    </Dropdown.Menu>
                    
                </Dropdown>
                <Button icon size="small" floated="right">
                    <Icon name="random"></Icon>
                </Button>
                

                <Segment basic inverted fitted>
                    <Form size="tiny" inverted > 
                        <Fields  grouped>
                            <Field > 
                                <label>Multiplier</label>                           
                                 <input
                                    type="text"
                                    bind:value={activeBetMultiplier}
                                    disabled="disabled" />
                            </Field>
                            <Field>
                                <label basic inverted slots="label">Amount</label>                           
                                <input
                                    type="text"
                                    bind:value={activeBetTotalAmount}
                                    disabled="disabled"/>
                            </Field>
                        </Fields>
                    </Form>
                   
                </Segment>


                {#if bet?.data?.active === true}
                    <Button fluid size="large" color="green" on:click={ cashout }> Cashout </Button>
                {:else}
                    <Button fluid size="large" color="orange" on:click={ placeBet }> Bet </Button>
                {/if}
               
               
            </Segment>
        </div>
        <div class="flex-item">
            <PlayingCard {...  activeCard } size="large" noFlip={true}></PlayingCard>
        </div>
        <div class="flex-item">
            <Buttons vertical size="huge">
                <Button bind:this={Controls.btn_higher}  on:click={ ()=>{ next("higherEqual") } } color="orange" inverted > ▲ </Button>
                <Button bind:this={Controls.btn_equal} on:click={ ()=>{ next("equal") } }  color="yellow" inverted > = </Button>
                <Button bind:this={Controls.btn_lower}  on:click={ ()=>{ next("lowerEqual") } } color="orange" inverted > ▼ </Button>
            </Buttons>
        </div>
        <div class="flex-item">
           
            <Table very basic inverted compact collapsing celled selectable>
                <Table.Header>
                    <Table.Row>
                        <Table.Hcell textAlign="center"> count </Table.Hcell>
                        <Table.Hcell textAlign="center"> Rank </Table.Hcell>
                      
                    </Table.Row>                 
                </Table.Header>    
                <Table.Body>
                    {#each Object.keys(CardCounter) as rank (rank)}
                        <Table.Row>
                            <Table.Cell textAlign="center"> {CardCounter[rank].session} </Table.Cell>
                            <Table.Cell textAlign="center"> <span class="ui text grey"><b>{rank}</b></span></Table.Cell>
                           
                        </Table.Row>
                     {/each}
              
                </Table.Body>
            </Table>
        </div>

    </div>
   
    <Statistic size="small" inverted>    
        <Statistic.Value text={true}>          
            <Statistic.Label><Text class="small">Result: </Text></Statistic.Label>
        </Statistic.Value>
    </Statistic>
    <div bind:this={div_rounds} class="rounds-container">
        <div>
            {#if  bet?.data?.state}
                 <PlayingCard {...bet.data.state.startCard} size="small" noFlip={true}></PlayingCard>
                {#each bet.data.state.rounds as round,i (i)}
                    <PlayingCard {...round.card} size="small" disabled={ round.guess == "skip" ? true : false } noFlip={true}></PlayingCard>
                {/each}
            {/if}
        </div>
    </div>
</div>

<style>

:global(.ui.dropdown .text.red) {
     color: #b41e1e;
 }

:global(.ui.dropdown .f-large) {
    font-size: 1.2rem !important;
 }

 :global(.ui.dropdown .text.black) {
     color: #131313;
 }

 span.text { 
  /*   font-size: 1.15em;*/
 }

.display-container {
       /* width: auto;*/
        margin: auto;
      
    }

.rounds-container::-webkit-scrollbar-thumb {
  background: #a3a3a3; 
 border-radius: 14px;
}
.rounds-container::-webkit-scrollbar-thumb:hover {
  background: #7a7a7a; 

}

.rounds-container {
        width: auto;
        overflow: auto;
        white-space: nowrap;
        padding-block: 0.1em;
}

.flex-container {
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
    }

.flex-item {
        flex: 0 0 20%;
        padding: 4px;
        margin: 8px;
    /*    width: var(--itemSize);*/
    /*    height: var(--itemSize);*/
    /*  outline: 1px solid #696969;*/
     /*  background-color: #ececec;*/
    }

    .t-left {
        text-align: left !important;
    }
</style>
